import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import toast from "react-hot-toast";
import { globalJson } from "global/global_json";
import { ContactFun } from "api/profile/profile";
import RentalPolicies from "components/RentalPolicies/RentalPolicies";

export interface PageContactProps {
  className?: string;
  asSection?: boolean;
}

const contacts = [
  {
    id: 1,
    icon: (
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3291 3.08238C11.2367 1.19716 9.29636 0.0454089 7.13864 0.00139331C7.04653 -0.000505127 6.95383 -0.000505127 6.86168 0.00139331C4.704 0.0454089 2.76366 1.19716 1.67121 3.08238C0.554581 5.00937 0.52403 7.32405 1.58948 9.27421L6.05302 17.4441C6.05502 17.4477 6.05703 17.4513 6.0591 17.4549C6.25548 17.7962 6.60729 18 7.00023 18C7.39314 18 7.74495 17.7962 7.9413 17.4549C7.94337 17.4513 7.94537 17.4477 7.94738 17.4441L12.4109 9.27421C13.4763 7.32405 13.4457 5.00937 12.3291 3.08238ZM7.00016 8.15624C5.60442 8.15624 4.46891 7.02073 4.46891 5.62499C4.46891 4.22925 5.60442 3.09374 7.00016 3.09374C8.3959 3.09374 9.53141 4.22925 9.53141 5.62499C9.53141 7.02073 8.39594 8.15624 7.00016 8.15624Z"
          fill="#F4A84A"
        />
      </svg>
    ),
    title: "Office Location",
    detail: globalJson.address,
  },
  {
    id: 2,
    icon: (
      <svg
        width="15"
        height="18"
        viewBox="0 0 15 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2947 14.3934C14.3734 14.4945 14.4289 14.6037 14.4604 14.7211C14.5039 14.8837 14.5014 15.0465 14.4526 15.2107C14.4041 15.3744 14.3118 15.5146 14.1763 15.6306L13.5373 16.1685C13.2869 16.3745 13.0266 16.5452 12.7565 16.6805C12.4863 16.8158 12.2053 16.9228 11.913 17.0011C11.443 17.1271 10.9579 17.1733 10.4573 17.14C9.95679 17.1066 9.458 17.0003 8.96106 16.8216C8.46412 16.6429 7.97654 16.396 7.49896 16.0817C7.02126 15.767 6.5689 15.3948 6.14261 14.9644C5.88214 14.7323 5.60174 14.463 5.30099 14.1565C5.04587 13.8953 4.74995 13.5799 4.41271 13.2099C4.07558 12.8403 3.72397 12.4235 3.35738 11.9608C2.98561 11.4992 2.67933 11.091 2.43896 10.7362C2.19848 10.381 2.00618 10.084 1.8629 9.84491C1.69529 9.56571 1.56626 9.32235 1.47591 9.11524C1.24941 8.74635 1.05474 8.3712 0.8923 7.98966C0.729864 7.60813 0.596744 7.22282 0.49263 6.83427C0.35649 6.32618 0.27666 5.82384 0.252491 5.3265C0.228321 4.82915 0.267883 4.35004 0.370332 3.88939C0.472781 3.42873 0.643255 2.99557 0.881752 2.5899C1.12025 2.18423 1.43383 1.82227 1.82227 1.50317L2.45396 0.978568C2.55455 0.899556 2.66213 0.844927 2.77617 0.814372C2.93666 0.771369 3.09805 0.775654 3.26046 0.82765C3.42244 0.879759 3.55927 0.974822 3.67021 1.11349L5.90043 3.89054C5.97955 3.99156 6.03418 4.09914 6.06474 4.21318C6.10966 4.38085 6.10812 4.54739 6.05967 4.71292C6.01123 4.87845 5.91823 5.01789 5.78013 5.13095L4.53035 6.16836C4.36518 6.30542 4.25511 6.47071 4.19952 6.66531C4.14435 6.85981 4.14242 7.05361 4.19425 7.24705C4.23363 7.39402 4.29809 7.52477 4.38816 7.63961L8.16027 12.3565C8.30703 12.5376 8.47383 12.655 8.6615 12.7083C8.84875 12.7618 9.03788 12.7632 9.22794 12.7123C9.3576 12.6775 9.48187 12.6126 9.60087 12.5177L10.8506 11.4803C10.9501 11.4021 11.0567 11.3473 11.1707 11.3167C11.3279 11.2746 11.4884 11.2791 11.6521 11.3308C11.8158 11.3824 11.954 11.4762 12.0666 11.6126L14.2947 14.3934Z"
          fill="#F4A84A"
        />
      </svg>
    ),
    title: "Phone",
    detail: globalJson.phone,
  },
  {
    id: 3,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.8414 3.57593L12.3823 8.9998L17.8414 14.4237C17.94 14.2174 17.9999 13.9894 17.9999 13.7459V4.25371C17.9999 4.01018 17.94 3.78219 17.8414 3.57593Z"
          fill="#F4A84A"
        />
        <path
          d="M16.418 2.67188H1.58207C1.33855 2.67188 1.11056 2.73175 0.904297 2.83043L7.88151 9.7725C8.49843 10.3894 9.50165 10.3894 10.1186 9.7725L17.0958 2.83043C16.8895 2.73175 16.6615 2.67188 16.418 2.67188Z"
          fill="#F4A84A"
        />
        <path
          d="M0.158555 3.57593C0.0598711 3.78219 0 4.01018 0 4.25371V13.7459C0 13.9894 0.0598711 14.2174 0.158555 14.4237L5.61758 8.9998L0.158555 3.57593Z"
          fill="#F4A84A"
        />
        <path
          d="M11.6368 9.74573L10.8643 10.5182C9.83634 11.5461 8.16371 11.5461 7.13578 10.5182L6.36332 9.74573L0.904297 15.1696C1.11056 15.2683 1.33855 15.3282 1.58207 15.3282H16.418C16.6615 15.3282 16.8895 15.2683 17.0958 15.1696L11.6368 9.74573Z"
          fill="#F4A84A"
        />
      </svg>
    ),
    title: "Email",
    detail: globalJson.email,
  },
];

const PageContact: FC<PageContactProps> = ({
  className = "",
  asSection = false,
}) => {
  const [getEmail, setEmail] = useState("");
  const [newName, setNewName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!getEmail.trim() || !emailRegex.test(getEmail)) {
      toast.error("Please enter a valid email address");
      setLoading(false);
      return;
    }

    if (getEmail.length === 0 || newName.length === 0 || message.length === 0) {
      toast.error("Fields are required!");
      setLoading(false);
      return;
    }

    // Create the payload with name, email, and message
    const companyPayload = {
      comapny:
        process.env.REACT_APP_ENV !== "prod"
          ? globalJson.dev_company_id
          : globalJson.prod_company_id,
      name: newName,
      email: getEmail,
      message: message,
    };
    const renterPayload = {
      name: newName,
      email: getEmail,
      message: message,
    };

    const result = await ContactFun(companyPayload);
    const result1 = await ContactFun(renterPayload);

    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("Sent successfully!");
      setEmail("");
      setNewName("");
      setMessage("");
    }

    setLoading(false);
  };

  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      {!asSection && (
        <Helmet>
          <title>Contact</title>
        </Helmet>
      )}
      <div className="container mx-auto">
        <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-12  rounded-lg py-16 px-12">
          <div className="mt-8 ">
            <h2 className="text-5xl font-medium">
              Have questions?
              <br /> Get in touch!
            </h2>
            <div className="flex flex-col mt-6">
              <div className=" space-y-6">
                {contacts.map((contact) => (
                  <div key={contact.id} className="flex items-center space-x-4">
                    {/* Icon */}
                    <div className="flex items-center justify-center  ">
                      {contact.icon}
                    </div>

                    {/* Text */}
                    <div>
                      <p className="text-[#121212] text-sm font-medium">
                        {contact.detail}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <div className="py-4"></div>
            <form className="grid grid-cols-1 gap-6" onSubmit={sendEmail}>
              <label className="block">
                <Input
                  placeholder="Name"
                  type="text"
                  className="mt-1"
                  value={newName}
                  onChange={(e) => {
                    setNewName(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Input
                  type="email"
                  placeholder="Email"
                  className="mt-1"
                  value={getEmail}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Textarea
                  className="mt-1"
                  placeholder="Message"
                  rows={6}
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                />
              </label>
              <div>
                <ButtonPrimary type="submit" className="min-w-[200px]">
                  {loading ? (
                    <div className="flex justify-center items-center col-span-full">
                      <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                    </div>
                  ) : (
                    "Send Message"
                  )}
                </ButtonPrimary>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="container relative py-16">
        <RentalPolicies />
      </div>
    </div>
  );
};

export default PageContact;
